import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date-select" }

import { ref, onMounted } from 'vue';
import moment from 'moment';


export default {
  __name: 'DateSelect',
  props: ['min', 'max', 'modelValue'],
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit;

const value = ref()
const date = ref(['2000', '01', '01']);
const minDate = ref(new Date(1910, 0, 1));
onMounted(() => {
  if(props.min) {
    minDate.value = props.min
  }
  if(props.max) {
    maxDate.value = props.max
  }
  if(props.modelValue) {
    value.value = moment(props.modelValue * 1000);
    date.value = value.value.format('YYYY-MM-DD').split('-');
  }
})

const updateValue = (values) => {
  emit('update:modelValue', moment(date.value.join('-')).unix());
  emit('onClose');
}

return (_ctx, _cache) => {
  const _component_van_date_picker = _resolveComponent("van-date-picker")
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: true,
      position: "bottom",
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_date_picker, {
          modelValue: date.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((date).value = $event)),
          title: "Select Date",
          "min-date": minDate.value,
          "max-date": _ctx.maxDate,
          onConfirm: updateValue,
          onCancel: _cache[1] || (_cache[1] = $event => (emit('onClose')))
        }, null, 8, ["modelValue", "min-date", "max-date"])
      ]),
      _: 1
    })
  ]))
}
}

}